const concat = (parameters = []) => {
  return parameters.filter((x) => x).join('');
};

export const siteUrl = (url) => concat([process.env.CLIENT_SITE_BASE_URL, url]);
export const contentApi = (url) => concat([process.env.CONTENT_API, url]);
export const middlewareApi = (url) => concat([process.env.MIDDLEWARE_API, url]);
export const commerceApi = (url) => concat([process.env.COMMERCE_API, url]);
